"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.preferenceCheck = exports.OpenSankeyDefaultModalePreferenceContent = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_bootstrap_1 = require("react-bootstrap");
// import i18next  from './traduction'
const modalPreferencePropTypes = {
    showPreference: prop_types_1.default.bool.isRequired,
    setShowPreference: prop_types_1.default.func.isRequired,
    ui: prop_types_1.default.arrayOf(prop_types_1.default.oneOfType([prop_types_1.default.arrayOf(prop_types_1.default.element), prop_types_1.default.element]).isRequired).isRequired
};
const OpenSankeyDefaultModalePreferenceContent = (t, data, set_data, trad) => {
    const ui = {
        'lang': react_1.default.createElement(react_bootstrap_1.Form.Group, { key: '1', as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                react_1.default.createElement(react_bootstrap_1.Form.Label, { style: { marginTop: '0.5em' } }, trad.language.toUpperCase())),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.Form.Check, { key: '', inline: true, style: { marginTop: '0.5em', marginLeft: '0.em' }, type: 'switch', checked: trad.language == 'en', onChange: evt => {
                        trad.changeLanguage((evt.target.checked) ? 'en' : 'fr');
                        set_data(Object.assign({}, data));
                    } }))),
        'mode_expert': react_1.default.createElement(react_bootstrap_1.ButtonGroup, { key: '3' },
            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', disabled: data.static_sankey, onClick: () => {
                    data.accordeonToShow = ['MEP'];
                    set_data(Object.assign({}, data));
                } }, "Simple"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'dark', disabled: data.static_sankey, onClick: () => {
                    data.accordeonToShow = ['MEP', 'EN', 'EF', 'ED', 'LL', 'Vis', 'Leg'];
                    set_data(Object.assign({}, data));
                } }, "Expert")),
        'form': [react_1.default.createElement(react_bootstrap_1.Form.Check, { key: 'MEP', disabled: data.static_sankey, checked: data.accordeonToShow.includes('MEP'), type: "checkbox", label: t('Menu.MEP'), onChange: () => {
                    exports.preferenceCheck('MEP', data);
                    set_data(Object.assign({}, data));
                } }), react_1.default.createElement(react_bootstrap_1.Form.Check, { key: 'Node', checked: !data.static_sankey, disabled: true, type: "checkbox", label: t('Menu.Noeuds') }), react_1.default.createElement(react_bootstrap_1.Form.Check, { key: 'EN', disabled: data.static_sankey, checked: data.accordeonToShow.includes('EN'), type: "checkbox", label: t('Menu.EN'), onChange: () => {
                    react_bootstrap_1.Form.Check;
                    exports.preferenceCheck('EN', data);
                    set_data(Object.assign({}, data));
                } }), react_1.default.createElement(react_bootstrap_1.Form.Check, { key: 'flux', checked: !data.static_sankey, disabled: true, type: "checkbox", label: t('Menu.flux') }), react_1.default.createElement(react_bootstrap_1.Form.Check, { key: 'ef', disabled: data.static_sankey, checked: data.accordeonToShow.includes('EF'), type: "checkbox", label: t('Menu.EF'), onChange: () => {
                    exports.preferenceCheck('EF', data);
                    set_data(Object.assign({}, data));
                } }), react_1.default.createElement(react_bootstrap_1.Form.Check, { key: 'ed', disabled: data.static_sankey, checked: data.accordeonToShow.includes('ED'), type: "checkbox", label: t('Menu.ED'), onChange: () => {
                    exports.preferenceCheck('ED', data);
                    set_data(Object.assign({}, data));
                } }), react_1.default.createElement(react_bootstrap_1.Form.Check, { key: 'leg', disabled: data.static_sankey, checked: data.accordeonToShow.includes('Leg'), type: "checkbox", label: t('Menu.Leg'), onChange: () => {
                    exports.preferenceCheck('Leg', data);
                    set_data(Object.assign({}, data));
                } })]
    };
    return ui;
};
exports.OpenSankeyDefaultModalePreferenceContent = OpenSankeyDefaultModalePreferenceContent;
const preferenceCheck = (str, data) => {
    if (!data.accordeonToShow.includes(str)) {
        data.accordeonToShow.push(str);
    }
    else {
        const posElemt = data.accordeonToShow.indexOf(str);
        data.accordeonToShow.splice(posElemt, 1);
    }
};
exports.preferenceCheck = preferenceCheck;
const ModalPreference = ({ showPreference, setShowPreference, ui }) => {
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: showPreference, onHide: () => { setShowPreference(false); } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u00C9dition Pr\u00E9ferences")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null, Object.values(ui).map((d, i) => {
            return react_1.default.createElement(react_1.default.Fragment, { key: i }, d);
        })),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => { setShowPreference(false); } }, "Close"))));
};
ModalPreference.propTypes = modalPreferencePropTypes;
exports.default = ModalPreference;
